import { render, staticRenderFns } from "./comparison.vue?vue&type=template&id=2e95379e&"
import script from "./comparison.vue?vue&type=script&lang=js&"
export * from "./comparison.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports